import isEmpty from 'lodash/isEmpty';
import APIService from '../APIService';
import { API_HOST, apiEndpoints } from '../../constants/APIConstants';

export default {
  updateProfile(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      else
        APIService.request(
          {
            method: 'PATCH',
            data: options,
            url: `${API_HOST}${apiEndpoints.USER_PROFILE}`,
            isAuthenticated: true,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
    });
  },
  getUserProfile() {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          method: 'GET',
          url: `${API_HOST}${apiEndpoints.USER_PROFILE}`,
        },
        (error, data) => {
          if (error) {
            reject(error);
          } else if (data) {
            resolve(data);
          } else {
            resolve(null);
          }
        }
      );
    });
  },
  getUserDetails() {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          method: 'GET',
          url: `${API_HOST}${apiEndpoints.PROFILE}`,
        },
        (error, data) => {
          if (error) {
            reject(error);
          } else if (data) {
            resolve(data);
          } else {
            resolve(null);
          }
        }
      );
    });
  },
  getJobCategories() {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          method: 'GET',
          url: `${API_HOST}${apiEndpoints.JOB_CATEGORIES}`,
        },
        (error, data) => {
          if (error) {
            reject(error);
          } else if (data) {
            resolve(data);
          } else {
            resolve(null);
          }
        }
      );
    });
  },
  fetchRequirements() {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          method: 'GET',
          url: `${API_HOST}${apiEndpoints.JOB_REQUIREMENTS}`,
        },
        (error, data) => {
          if (error) {
            reject(error);
          } else if (data) {
            resolve(data);
          } else {
            resolve(null);
          }
        }
      );
    });
  },
};
